import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" fill="none" viewBox="0 0 24 17">
    <g id="Group 920">
      <path id="Vector" fill="red" d="M23.498 2.675A3.02 3.02 0 0 0 21.376.539C19.506.035 12 .035 12 .035s-7.505 0-9.376.504A3.02 3.02 0 0 0 .502 2.675C0 4.559 0 8.489 0 8.489s0 3.93.502 5.815a3.02 3.02 0 0 0 2.122 2.135c1.872.505 9.376.505 9.376.505s7.506 0 9.376-.505a3.02 3.02 0 0 0 2.122-2.135C24 12.42 24 8.489 24 8.489s0-3.93-.502-5.814"></path>
      <path id="Vector_2" fill="#fff" d="m9.545 12.058 6.273-3.569L9.545 4.92z"></path>
    </g>
  </svg>;
export default SvgIcon;